import React, { useState, useEffect, useRef } from "react";
import Dropzone from "react-dropzone";
import { Alert } from "reactstrap";
import DjangoForm from "./django-form.component";
import { service as neoImporter } from "../redux";

const Importer = (props) => {
    const {
        fileId,
        redirected,
        finished,
        extraFields,
        contentType,
        extraParams = {},
        template_file,
        processUrl,
        uploadSucessfull
    } = props;

    const [file, setFile] = useState(null);
    const [errorMessage, setErrorMessage] = useState([]);
    const [loading, setLoading] = useState(false);
    // const [isFinished, setIsFinished] = useState(false); // Used in class state 'finished', but never read in render?

    const djangoFormRef = useRef();
    const isMounted = useRef(true);

    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        if (fileId && errorMessage.length === 0 && !redirected) {
            finished();
            // setIsFinished(true); 
        }
    }, [fileId, errorMessage, redirected, finished]);

    const onDrop = files => {
        const newFile = files[0];
        setFile(newFile);
        setErrorMessage([]);
    };

    const onCancel = () => {
        setFile(null);
        setErrorMessage([]);
    };

    const serialize = (obj) => {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    };

    const onSubmit = () => {
        // Accessing values from the DjangoForm ref
        const formValues = djangoFormRef.current ? djangoFormRef.current.values : {};

        const combinedExtraParams = {
            ...extraParams,
            ...formValues
        };

        setLoading(true);
        neoImporter
            .fileUpload(processUrl, file, combinedExtraParams)
            .then(response => {
                if (isMounted.current) {
                    uploadSucessfull(response);
                    setLoading(false);
                    setFile(null);
                }
            })
            .catch(err => {

                if (err.response) {
                    const { status, data } = err.response;
                    if (status === 400) {
                        const messages = Object.keys(data).map(key => {
                            const value = data[key][0];
                            switch (key) {
                                case "uploaded_file":
                                    return value.replace(
                                        "None",
                                        `${process.env.REACT_APP_API_ENDPOINT_URL}${process.env.REACT_APP_API_VERSION}${template_file
                                        }?${serialize(combinedExtraParams)}`
                                    );
                                default:
                                    return `${key.replace(/\b\w/g, l => l.toUpperCase())}: ${value}`;
                            }
                        });
                        if (isMounted.current) {
                            setErrorMessage(messages);
                            setFile(null);
                            setLoading(false);
                        }
                    }
                }
                if (isMounted.current) {
                    setLoading(false);
                    setFile(null);
                }
            });
    };

    const zoneStyle = {
        width: "100%",
        height: 150,
        border: "2px dashed #888",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column"
    };


    return (
        <div className="row">
            {errorMessage.length > 0 &&
                errorMessage.map((msg, i) => (
                    <div className="col-md-12" key={`errorMessage_${i}`}>
                        <div
                            className="alert alert-danger"
                            dangerouslySetInnerHTML={{
                                __html: msg
                            }}
                        />
                    </div>
                ))}
            {file && <div className="col-md-12">
                <Alert>{file.name}</Alert>
            </div>}
            <div className="col-9">
                <Dropzone
                    disableClick
                    accept=".xls, .xlsx, .txt"
                    multiple={false}
                    style={zoneStyle}
                    onDrop={onDrop}
                    onFileDialogCancel={onCancel}
                >
                    {({ isDragActive, isDragReject, open }) => {
                        if (isDragActive) {
                            return <p>File accepted</p>;
                        }
                        if (isDragReject) {
                            return <p>Files rejected</p>;
                        }
                        return (
                            <React.Fragment>
                                <p>Dropping file here ... or</p>
                                <button className="btn btn-primary" type="button" onClick={() => open()}>
                                    Browse File
                                </button>
                            </React.Fragment>
                        );
                    }}
                </Dropzone>
                <div style={{ marginTop: "10px" }}>
                    <DjangoForm ref={djangoFormRef} fields={extraFields} />
                </div>
                <div className="controls">
                    {loading && (
                        <div style={{ marginBottom: "10px" }}>
                            <div className="importer-infinite-loader"></div>
                        </div>
                    )}
                    <button disabled={!file || loading} className="btn btn-primary" onClick={onSubmit}>
                        Import File
                    </button>
                </div>
            </div>
            <div className="col-3">
                <div className="card">
                    <h5 className="card-header bg-primary text-white">
                        {contentType} template download
                    </h5>
                    <div className="card-body">
                        <p className="card-text">
                            Please use this importer to upload{" "}
                            {contentType ? contentType.replace("Importer", "") : null} in XLS
                            file. You can download a template file{" "}
                            <a
                                rel="noopener"
                                href={`${process.env.REACT_APP_API_ENDPOINT_URL}${process.env.REACT_APP_API_VERSION
                                    }${template_file}?${serialize(extraParams)}`}
                            >
                                here!
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

Importer.propTypes = {};

export default Importer;
